import { gql, graphQueryBang } from "../../../shared/lib/graphql"
import { appletQueryFields as StaticAppletFragment } from "./reducers/applet"
import { serviceQueryFields as ServicesFragment } from "./reducers/services"

const PrivateServicesQuery = gql`
  query {
    me {
      private_channels {
        ${ServicesFragment}
      }
    }
  }
`

const StaticAppletQuery = gql`
  query(
    $applet_id: String!
  ) {
    applet(id: $applet_id) {
      ${StaticAppletFragment}
    }
  }
`

export function loadPrivateServices() {
  return graphQueryBang(PrivateServicesQuery).then(
    data => data.me.private_channels
  )
}

export function loadStaticApplet(appletId) {
  return graphQueryBang(StaticAppletQuery, {
    applet_id: appletId,
  }).then(data => data.applet)
}
